/* Registers the PWA service worker (offline shell + installability).
   Only runs on secure origins in production builds. */
export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const isSecure = window.location.protocol === "https:" || isLocalhost;
  if (!isSecure || process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        reg.onupdatefound = () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.onstatechange = () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage("SKIP_WAITING");
            }
          };
        };
      })
      .catch(() => {});
  });
}
